import { ReactNode } from 'react';
import { Popover, PopoverBody, PopoverContent, PopoverTrigger } from '@chakra-ui/popover';
import { CbButton } from 'ui/components/Buttons/CbButton';
interface BulkActionProps {
  bulkActions: ReactNode[];
}
export const BulkActions = ({
  bulkActions
}: BulkActionProps) => {
  return <Popover data-sentry-element="Popover" data-sentry-component="BulkActions" data-sentry-source-file="BulkActions.tsx">
      <PopoverTrigger data-sentry-element="PopoverTrigger" data-sentry-source-file="BulkActions.tsx">
        <CbButton size="sm" variant="outline" data-sentry-element="CbButton" data-sentry-source-file="BulkActions.tsx">
          Bulk Actions
        </CbButton>
      </PopoverTrigger>
      <PopoverContent data-sentry-element="PopoverContent" data-sentry-source-file="BulkActions.tsx">
        <PopoverBody data-sentry-element="PopoverBody" data-sentry-source-file="BulkActions.tsx">{bulkActions}</PopoverBody>
      </PopoverContent>
    </Popover>;
};